
import { Component, Vue } from 'vue-property-decorator'
import BgComp from '../components/bgComp.vue'
import { Getter } from 'vuex-class'
import { backToBefore } from '@/utils/h5ToApp'

@Component({
  components: {
    BgComp
  }
})
export default class approveFinish extends Vue {
  @Getter userId!: string
  @Getter info: any // 用户信息
  currentRate = 0
  isApproveShow = 2
  isApproveOk = false
  timeId = null
  timeValue = 3

  created() {
    console.log('route', this.$route.query)
    this.$bridge.callHandler('updateApproveInfo', {
      userOtherType:this.$route.query.userOtherType 
    }, (res) => {
      console.log('updateApproveInfo', res)
    })
    this.backTime()
  }
  handleBack() {
    backToBefore()
  }
  handleBtn() {
    // 如果是白条需求进入，直接进入支付界面
    clearInterval(this.timeId)
    let FDWhite = window.localStorage.getItem('FDWhite')
    if(FDWhite) {
      this.$router.push({
        path:'/authorizeConfirm'
      })
      return false
    }
    // 更新app端企业认证标识
    if (this.$route.query.flag === '2') {
      backToBefore()
    } else {
      // h5进入企业认证完成页面
      this.$router.push({
        name: 'CompanyApproveFinish',
        query:{
          formPage:'h5',
          isGestureInterception:'true'
        }
      })
    }
  }
  goFDWhite() {
    this.$router.push({
      path:'/authorizeConfirm'
    })
  }

  backTime() {
    if(this.$route.query.flag === '2') {
      this.timeId = setInterval(() => {
        this.timeValue--
        if(this.timeValue === 0) {
          clearInterval(this.timeId)
          this.handleBack()
          // console.log('1234');
          
        }
      }, 1000);
    }

  }
}
